/**
 * replaces array buffers with base64. This lies that the type hasn't been changed because array buffers
 * are typed as 'any' anyway.
 * @param value Any value that be JSON-encodable if it weren't for the presence of ArrayBuffers.
 * (Since it must otherwise be JSON-encodable, sets, maps, and other values that are not JSON-encodable are not supported)
 * @returns A value where all ArrayBuffers are converted to base64 values. (however, the types are left unchanged)
 */
export const replaceArrayBuffersWithBase64 = <T>(value: T, depth: number = 0, objectsSeen: Map<T, T> = new Map()): T => {
	if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean' || value == null) {
		return value;
	} else if (Array.isArray(value)) {
		if (objectsSeen.has(value)) {
			return objectsSeen.get(value) as T;
		}
		const replacement = [] as T;
		objectsSeen.set(value, replacement);
		for (const element of value) {
			(replacement as unknown[]).push(replaceArrayBuffersWithBase64(element, depth + 1, objectsSeen) as T);
		}
		return replacement;
	} else if (value instanceof ArrayBuffer) {
		const valueAsString = Array.from(new Uint8Array(value), v => String.fromCharCode(v)).join('');
		const b64 = btoa(valueAsString) as T;
		return b64;
	} else if (typeof value === 'object') {
		if (objectsSeen.has(value)) {
			return objectsSeen.get(value) as T;
		}
		const replacement = {} as T;
		objectsSeen.set(value, replacement);
		Object.assign(replacement as {}, Object.fromEntries(Object.entries(value).map(([key, value]) => [key, replaceArrayBuffersWithBase64(value, depth + 1, objectsSeen)])) as T);
		return replacement;
	} else {
		return value;
	}
};
